import React from 'react';
import cn from 'clsx';
import * as css from './styles.module.scss';

type Props = {
    size?: string | number;
    style?: CSSProperties;
    className?: string;
};

export function Play({ size = 28, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28 28"
            fill="none"
            style={{ ...style, width: size, height: size }}
            className={cn(css.play, className)}
        >
            <path
                fill="#fff"
                d="M9.49 20.86A1 1 0 0 0 10 21a1 1 0 0 0 .49-.1l11-6a1 1 0 0 0 0-1.76l-11-6a1 1 0 0 0-1 0A1 1 0 0 0 9 8v12a1 1 0 0 0 .49.86zM18.91 14 11 18.32V9.68Z"
                className={css.hideOnHover}
            />
            <circle cx="14" cy="14" r="12.983" stroke="#fff" fill="none" strokeWidth="2" />
            <path
                fill="none"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 0C6.268 0 0 6.268 0 14s6.268 14 14 14 14-6.268 14-14A14 14 0 0 0 14 0Zm-3 18.32L18.91 14 11 9.69Zm-.52 2.56 11-6 .01.02a1 1 0 0 0 0-1.76l-11-6a1 1 0 0 0-1 0A1 1 0 0 0 9 8v12a1 1 0 0 0 .48.88 1 1 0 0 0 1 0z"
                className={css.showOnHover}
            />
        </svg>
    );
}
